import { render, staticRenderFns } from "./InputFormItem.vue?vue&type=template&id=da457d3c&scoped=true&"
import script from "./InputFormItem.vue?vue&type=script&lang=js&"
export * from "./InputFormItem.vue?vue&type=script&lang=js&"
import style0 from "./InputFormItem.vue?vue&type=style&index=0&id=da457d3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da457d3c",
  null
  
)

export default component.exports